import * as React from "react";
import { Button, GridItem } from "@chakra-ui/react";
import {
  Form,
  PasswordInputs,
  Grid,
  ImageUploader,
  TextInput
} from "components";
import { Types } from "../../duck";
import { hooks, Types as EditTypes, utils } from "./duck";

interface EditProps {
  admin: Types.Admin;
  onCancel(): void;
  onSuccess(): void;
}

const Edit: React.FC<EditProps> = ({ onCancel, admin, onSuccess }) => {
  const onSubmit = hooks.useUpdateAdmin(admin._id, onSuccess);

  return (
    <Form<EditTypes.FormValues>
      {...utils.getValidation(admin)}
      onSubmit={onSubmit}
    >
      <Grid>
        <GridItem>
          <TextInput
            name="firstName"
            label="First Name"
            placeholder="First Name"
          />
        </GridItem>
        <GridItem>
          <TextInput
            name="lastName"
            label="Last Name"
            placeholder="Last Name"
          />
        </GridItem>
        <GridItem>
          <TextInput name="email" label="Email" placeholder="Email" />
        </GridItem>
        <PasswordInputs />
        <GridItem>
          <TextInput
            type="password"
            numeric
            name="pin"
            label="PIN"
            placeholder="PIN"
          />
        </GridItem>

        <GridItem colStart={1}>
          <ImageUploader name="image" label="Picture" />
        </GridItem>
      </Grid>

      <Form.Controls submitText="Save">
        <Button variant="outline" onClick={onCancel}>
          Cancel
        </Button>
      </Form.Controls>
    </Form>
  );
};

export default Edit;
